import React from 'react';

export default function TimeKeepingReport() {
  return <div>TimeKeepingReport</div>;
}
